module.exports = __webpack_public_path__ + "bf.svg?86ef8150c29ad916a2001ce020a62059";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bf.svg
// module id = 947
// module chunks = 27